import Conversation from './Conversation';
import utils from '@/utils/utils';
import style from './index.module.less';
import ChatInput from './ChatInput';
import ConversationHeader from '@/components/ConversationHeader/ConversationHeader';
import React from 'react';
import { useAppContent } from '@/context/AppContent';
import { createAiTalk } from '@/app/user';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store';
import { setHistoryMsg } from '@/store/slices/room';
import Config  from '@/config';

function Room() {
  const { sendMessage } = useAppContent();
  const { roomId, msgHistory } = useSelector((state: RootState) => state.room);
  const dispatch = useDispatch();

  const handleSendText = async (message: string) => {
    if (!message || message === '' || message.length == 0) {
      return;
    }

    const roleId = localStorage.getItem('roleId') || '';
    const userInfoString = localStorage.getItem('userInfo') || '{}';
    const userInfo = JSON.parse(userInfoString);

    const s = msgHistory.map((i) => i.value).join('\n');

    const prompt: string = Config.Prompt

    sendMessage(message, prompt);

    const payload = {
      type: 'text',
      persona_id: roleId,
      room_id: roomId || '',
      token: '',
      value: message,
      text: message,
      time: new Date().toString(),
      user: userInfo.id,
      paragraph: '1',
      definite: true,
      isInterrupted: '',
    };
    dispatch(setHistoryMsg(payload));
    await createAiTalk(payload);
  };

  return (
    <div className={style.roomWrapper}>
      <ConversationHeader />
      <div className={`${style.wrapper} ${utils.isMobile() ? style.mobile : ''}`}>
        <Conversation className={style.conversation} />
        <ChatInput onConfirm={handleSendText} />
      </div>
    </div>
  );
}

export default Room;
